import { ATTACHMENT_BOUNDARY_PATH_PREFIX } from "../../../common/constants";

export const COMMISSIONS_LEVEL_ROUTE_PREFIX = "/commissions/levels";

export const COMMISSIONS_LEVEL_ROUTE_PATHS = {
  list: { path: "*", to: COMMISSIONS_LEVEL_ROUTE_PREFIX },
  detail: { path: ":id", to: `${COMMISSIONS_LEVEL_ROUTE_PREFIX}/:id` },
  attachment: { to: `${ATTACHMENT_BOUNDARY_PATH_PREFIX}${COMMISSIONS_LEVEL_ROUTE_PREFIX}/:id1/attachments/:id2` },
};
